import Vuex from "vuex";
import { config } from "vuex-module-decorators";
import createPersistedState from "vuex-persistedstate";
import AppModule from "@/store/modules/AppModule";
import Cookies from "js-cookie";

config.rawError = true;

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    AppModule: AppModule
  },
  plugins: [createPersistedState({
    storage: window.localStorage
    /*storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: true }),
      removeItem: key => Cookies.remove(key)
    }*/
  })]
})
